import { __exportAll } from "./_virtual/_rolldown/runtime.js";
import { CardSchemeId } from "./card_scheme_id.js";
import "./gateway.js";
import { allEnumValues } from "./helper.js";
//#region src/card_scheme_id_helper.ts
var card_scheme_id_helper_exports = /* @__PURE__ */ __exportAll({
	getStoredValueAndLoyaltyIds: () => getStoredValueAndLoyaltyIds,
	isCampusCard: () => isCampusCard,
	isEbt: () => isEbt,
	isLoyalty: () => isLoyalty,
	isStoredValue: () => isStoredValue,
	isStoredValueOrLoyalty: () => isStoredValueOrLoyalty,
	name: () => name,
	stringFromEnum: () => stringFromEnum
});
function name(cardSchemeId) {
	switch (cardSchemeId) {
		case 0: return "Debit/Credit Card";
		case 1: return "Visa";
		case 2: return "MasterCard";
		case 3: return "Maestro";
		case 4: return "AmEx";
		case 5: return "JCB";
		case 6: return "Diners";
		case 7: return "Discover";
		case 10: return "Voyager";
		case 12: return "China UnionPay";
		case 100: return "Cash";
		case 1240: return "Debit";
		case 1241: return "Interac";
		case 1242: return "EBT Cash Benefit";
		case 1243: return "EBT Food Stamp";
		case 1244: return "ATH Móvil";
		case 10001: return "Square Gift Card";
		case 10002: return "Square EFT POS";
		case 67102: return "LevelUp Discount";
		case 67103: return "LevelUp Gift Card";
		case 67104: return "LevelUp Credit Card";
		case 67135: return "Love's Drink Refills";
		case 67134: return "Love's Rewards Points";
		case 67106: return "Atrium Student Card";
		case 67133: return "Atrium Meal Exchange";
		case 67101:
		case 67105:
		case 67108:
		case 67107:
		case 67110:
		case 67109:
		case 67111:
		case 67112:
		case 67113:
		case 67114: return "Gift Card";
		case 67138: return "Stored Value";
		case 67139: return "Voucher";
		case 67119: return "CBORD";
		case 67141: return "Transact Campus Card";
		case 67115: return "Chopt Discount";
		case 67116: return "Chopt Gift Card";
		case 67117: return "Chopt Credit Card";
		case 67118: return "Como Point Redemption";
		case 67120: return "Thanx Reward";
		case 67121: return "Thanx Point Redemption";
		case 67128: return "Par Pay Gift Card";
		case 67122: return "Punchh Credit Card";
		case 67123: return "Punchh Gift Card";
		case 67124: return "Punchh Discount";
		case 67137: return "Quickcharge";
		case 67125: return "Pinata Credit Card";
		case 67126: return "Pinata Gift Card";
		case 67127: return "Pinata Discount";
		case 67140: return "Appfront Payment";
		case 67142: return "Appfront Reward";
		case 67143: return "Givex Loyalty Reward";
		case 67144: return "Givex Loyalty Payment";
		case 67129: return "Smooth Commerce Payment";
		case 67130: return "Spendgo Reward";
		case 67131: return "Starbucks Card";
		case 67132: return "Starbucks Card";
		case 67136: return "Pinata Campus Card";
	}
}
/** Atrium campus and gift cards share a scheme and gateway; only the marker distinguishes them. */
function isCampusCard(cardSchemeId, gateway, isCampusCardTransaction = false) {
	switch (cardSchemeId) {
		case 67119:
		case 67136:
		case 67137:
		case 67141: return true;
		case 67106:
		case 67133: return gateway === 9 && isCampusCardTransaction;
		default: return false;
	}
}
function isStoredValue(cardSchemeId, gateway) {
	switch (cardSchemeId) {
		case 67106:
		case 67133: return gateway === 9;
		case 67131: return gateway === 49;
		case 1244:
		case 4:
		case 100:
		case 12:
		case 67115:
		case 1240:
		case 6:
		case 7:
		case 1242:
		case 1243:
		case 1241:
		case 5:
		case 67135:
		case 67134:
		case 3:
		case 2:
		case 0:
		case 67125:
		case 67127:
		case 67140:
		case 67142:
		case 67143:
		case 67144:
		case 67122:
		case 67124:
		case 67129:
		case 10002:
		case 67132:
		case 1:
		case 10: return false;
		case 67107:
		case 67119:
		case 67117:
		case 67116:
		case 67118:
		case 67114:
		case 67113:
		case 67138:
		case 67139:
		case 67105:
		case 67104:
		case 67102:
		case 67103:
		case 67111:
		case 67128:
		case 67110:
		case 67136:
		case 67126:
		case 67108:
		case 67123:
		case 67137:
		case 67130:
		case 10001:
		case 67101:
		case 67121:
		case 67120:
		case 67141:
		case 67109:
		case 67112: return true;
	}
}
function isStoredValueOrLoyalty(cardSchemeId) {
	switch (cardSchemeId) {
		case 4:
		case 1244:
		case 100:
		case 12:
		case 1240:
		case 6:
		case 7:
		case 1242:
		case 1243:
		case 1241:
		case 5:
		case 3:
		case 2:
		case 0:
		case 67125:
		case 10002:
		case 1:
		case 10: return false;
		case 67107:
		case 67106:
		case 67133:
		case 67119:
		case 67117:
		case 67115:
		case 67116:
		case 67118:
		case 67114:
		case 67113:
		case 67138:
		case 67139:
		case 67105:
		case 67104:
		case 67102:
		case 67103:
		case 67135:
		case 67134:
		case 67111:
		case 67128:
		case 67110:
		case 67136:
		case 67127:
		case 67126:
		case 67108:
		case 67122:
		case 67124:
		case 67123:
		case 67140:
		case 67142:
		case 67143:
		case 67144:
		case 67137:
		case 67129:
		case 67130:
		case 10001:
		case 67131:
		case 67132:
		case 67101:
		case 67121:
		case 67120:
		case 67141:
		case 67109:
		case 67112: return true;
	}
}
function getStoredValueAndLoyaltyIds() {
	return allEnumValues(CardSchemeId).filter(isStoredValueOrLoyalty);
}
function isLoyalty(cardSchemeId, gateway) {
	switch (cardSchemeId) {
		case 67106: return gateway === 43;
		case 67131: return gateway === 42;
		case 67133:
		case 67115:
		case 67118:
		case 67102:
		case 67135:
		case 67134:
		case 67125:
		case 67127:
		case 67126:
		case 67122:
		case 67124:
		case 67123:
		case 67140:
		case 67142:
		case 67143:
		case 67144:
		case 67129:
		case 67130:
		case 67132:
		case 67121:
		case 67120: return true;
		case 4:
		case 67107:
		case 1244:
		case 100:
		case 67119:
		case 12:
		case 67117:
		case 67116:
		case 1240:
		case 6:
		case 7:
		case 1242:
		case 1243:
		case 67114:
		case 67113:
		case 67138:
		case 67139:
		case 67105:
		case 1241:
		case 5:
		case 67104:
		case 67103:
		case 3:
		case 2:
		case 67111:
		case 0:
		case 67128:
		case 67110:
		case 67136:
		case 67108:
		case 67137:
		case 10002:
		case 10001:
		case 67101:
		case 67141:
		case 67109:
		case 1:
		case 10:
		case 67112: return false;
	}
}
function stringFromEnum(cardSchemeId) {
	switch (cardSchemeId) {
		case 0: return "other";
		case 1: return "visa";
		case 2: return "master-card";
		case 3: return "maestro";
		case 4: return "amex";
		case 5: return "jcb";
		case 6: return "diners";
		case 7: return "discover";
		case 10: return "voyager";
		case 67119: return "cbord";
		case 67137: return "quickcharge";
		case 12: return "china-union-pay";
		case 100: return "cash";
		case 1240: return "debit";
		case 1241: return "interac";
		case 1242: return "ebt-cash-benefit";
		case 1243: return "ebt-food-stamp";
		case 1244: return "ath-movil";
		case 10001: return "square-gift-card";
		case 10002: return "square-eft-pos";
		case 67102: return "level-up-discount";
		case 67103: return "level-up-gift-card";
		case 67104: return "level-up-credit-card";
		case 67135: return "loves-drink-refills";
		case 67134: return "loves-rewards-points";
		case 67106: return "atrium";
		case 67133: return "atrium-meal-exchange";
		case 67101: return "tcc";
		case 67105: return "givex";
		case 67108: return "pinata-stored-value";
		case 67107: return "archer";
		case 67110: return "paytronix-gift-card";
		case 67109: return "valutec";
		case 67111: return "olo-gift-card";
		case 67112: return "worldpay-gift-card";
		case 67113: return "freedom-pay-gift-card";
		case 67138: return "freedom-pay-stored-value";
		case 67139: return "freedom-pay-voucher";
		case 67114: return "eigen-gift-card";
		case 67115: return "chopt-discount";
		case 67116: return "chopt-gift-card";
		case 67117: return "chopt-credit-card";
		case 67118: return "como-point-redemption";
		case 67120: return "thanx-reward";
		case 67121: return "thanx-point-redemption";
		case 67128: return "par-pay-gift-card";
		case 67122: return "punchh-credit-card";
		case 67123: return "punchh-gift-card";
		case 67124: return "punchh-discount";
		case 67125: return "pinata-credit-card";
		case 67126: return "pinata-gift-card";
		case 67127: return "pinata-discount";
		case 67140: return "appfront-payment";
		case 67142: return "appfront-reward";
		case 67143: return "givex-loyalty-reward";
		case 67144: return "givex-loyalty-payment";
		case 67129: return "smooth-commerce-payment";
		case 67130: return "spendgo-reward";
		case 67131: return "starbucks-stored-value";
		case 67132: return "starbucks-reward";
		case 67136: return "pinata-campus-card";
		case 67141: return "transact-campus-card";
	}
}
function isEbt(cardSchemeId) {
	switch (cardSchemeId) {
		case 1242:
		case 1243: return true;
		case 4:
		case 67107:
		case 1244:
		case 67106:
		case 67133:
		case 100:
		case 67119:
		case 12:
		case 67117:
		case 67115:
		case 67116:
		case 67118:
		case 1240:
		case 6:
		case 7:
		case 67114:
		case 67113:
		case 67138:
		case 67139:
		case 67105:
		case 1241:
		case 5:
		case 67104:
		case 67102:
		case 67103:
		case 67135:
		case 67134:
		case 3:
		case 2:
		case 67111:
		case 0:
		case 67110:
		case 67108:
		case 67123:
		case 67122:
		case 67124:
		case 67137:
		case 10002:
		case 10001:
		case 67101:
		case 67109:
		case 1:
		case 10:
		case 67112:
		case 67120:
		case 67121:
		case 67128:
		case 67125:
		case 67126:
		case 67127:
		case 67140:
		case 67142:
		case 67143:
		case 67144:
		case 67129:
		case 67130:
		case 67131:
		case 67132:
		case 67136:
		case 67141: return false;
	}
}
//#endregion
export { card_scheme_id_helper_exports, getStoredValueAndLoyaltyIds, isCampusCard, isEbt, isLoyalty, isStoredValue, isStoredValueOrLoyalty, name, stringFromEnum };

//# sourceMappingURL=card_scheme_id_helper.js.map